import 'core-js/modules/es7.symbol.async-iterator';
import 'core-js/modules/es6.symbol';
import 'core-js/modules/web.dom.iterable';
import _classCallCheck from '/var/www/lime25/limesurvey/assets/packages/textelements/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck';
import _createClass from '/var/www/lime25/limesurvey/assets/packages/textelements/node_modules/@babel/runtime-corejs2/helpers/esm/createClass';
import _possibleConstructorReturn from '/var/www/lime25/limesurvey/assets/packages/textelements/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '/var/www/lime25/limesurvey/assets/packages/textelements/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf';
import _inherits from '/var/www/lime25/limesurvey/assets/packages/textelements/node_modules/@babel/runtime-corejs2/helpers/esm/inherits';
/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module table/tableui
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import {
    addListToDropdown,
    createDropdown
} from '@ckeditor/ckeditor5-ui/src/dropdown/utils';
import Model from '@ckeditor/ckeditor5-ui/src/model';
import Collection from '@ckeditor/ckeditor5-utils/src/collection';
import InsertTableView from './ui/inserttableview';
import tableIcon from './../theme/icons/table.svg';
import tableColumnIcon from './../theme/icons/table-column.svg';
import tableRowIcon from './../theme/icons/table-row.svg';
import tableMergeCellIcon from './../theme/icons/table-merge-cell.svg';
/**
 * The table UI plugin. It introduces:
 *
 * * The `'insertTable'` dropdown,
 * * The `'tableColumn'` dropdown,
 * * The `'tableRow'` dropdown,
 * * The `'mergeTableCells'` dropdown.
 *
 * The `'tableColumn'`, `'tableRow'`, `'mergeTableCells'` dropdowns work best with {@link module:table/tabletoolbar~TableToolbar}.
 *
 * @extends module:core/plugin~Plugin
 */
var TableUI = /*#__PURE__*/
function (_Plugin) {
    _inherits(TableUI, _Plugin);
    function TableUI() {
        _classCallCheck(this, TableUI);
        return _possibleConstructorReturn(this, _getPrototypeOf(TableUI).apply(this, arguments));
    }
    _createClass(TableUI, [
        {
            key: 'init',
            /**
     * @inheritDoc
     */
            value: function init() {
                var _this = this;
                var editor = this.editor;
                var t = this.editor.t;
                var contentLanguageDirection = editor.locale.contentLanguageDirection;
                var isContentLtr = contentLanguageDirection === 'ltr';
                editor.ui.componentFactory.add('insertTable', function (locale) {
                    var command = editor.commands.get('insertTable');
                    var dropdownView = createDropdown(locale);
                    dropdownView.bind('isEnabled').to(command);
                    // Decorate dropdown's button.
                    dropdownView.buttonView.set({
                        icon: tableIcon,
                        label: t('Insert table'),
                        tooltip: true
                    });
                    // Prepare custom view for dropdown's panel.
                    var insertTableView = new InsertTableView(locale);
                    dropdownView.panelView.children.add(insertTableView);
                    insertTableView.delegate('execute').to(dropdownView);
                    dropdownView.buttonView.on('open', function () {
                        // Reset the chooser before showing it to the user.
                        insertTableView.rows = 0;
                        insertTableView.columns = 0;
                    });
                    dropdownView.on('execute', function () {
                        editor.execute('insertTable', {
                            rows: insertTableView.rows,
                            columns: insertTableView.columns
                        });
                        editor.editing.view.focus();
                    });
                    return dropdownView;
                });
                editor.ui.componentFactory.add('tableColumn', function (locale) {
                    var options = [
                        {
                            type: 'switchbutton',
                            model: {
                                commandName: 'setTableColumnHeader',
                                label: t('Header column'),
                                bindIsOn: true
                            }
                        },
                        { type: 'separator' },
                        {
                            type: 'button',
                            model: {
                                commandName: isContentLtr ? 'insertTableColumnLeft' : 'insertTableColumnRight',
                                label: t('Insert column left')
                            }
                        },
                        {
                            type: 'button',
                            model: {
                                commandName: isContentLtr ? 'insertTableColumnRight' : 'insertTableColumnLeft',
                                label: t('Insert column right')
                            }
                        },
                        {
                            type: 'button',
                            model: {
                                commandName: 'removeTableColumn',
                                label: t('Delete column')
                            }
                        }
                    ];
                    return _this._prepareDropdown(t('Column'), tableColumnIcon, options, locale);
                });
                editor.ui.componentFactory.add('tableRow', function (locale) {
                    var options = [
                        {
                            type: 'switchbutton',
                            model: {
                                commandName: 'setTableRowHeader',
                                label: t('Header row'),
                                bindIsOn: true
                            }
                        },
                        { type: 'separator' },
                        {
                            type: 'button',
                            model: {
                                commandName: 'insertTableRowBelow',
                                label: t('Insert row below')
                            }
                        },
                        {
                            type: 'button',
                            model: {
                                commandName: 'insertTableRowAbove',
                                label: t('Insert row above')
                            }
                        },
                        {
                            type: 'button',
                            model: {
                                commandName: 'removeTableRow',
                                label: t('Delete row')
                            }
                        }
                    ];
                    return _this._prepareDropdown(t('Row'), tableRowIcon, options, locale);
                });
                editor.ui.componentFactory.add('mergeTableCells', function (locale) {
                    var options = [
                        {
                            type: 'button',
                            model: {
                                commandName: 'mergeTableCellUp',
                                label: t('Merge cell up')
                            }
                        },
                        {
                            type: 'button',
                            model: {
                                commandName: isContentLtr ? 'mergeTableCellRight' : 'mergeTableCellLeft',
                                label: t('Merge cell right')
                            }
                        },
                        {
                            type: 'button',
                            model: {
                                commandName: 'mergeTableCellDown',
                                label: t('Merge cell down')
                            }
                        },
                        {
                            type: 'button',
                            model: {
                                commandName: isContentLtr ? 'mergeTableCellLeft' : 'mergeTableCellRight',
                                label: t('Merge cell left')
                            }
                        },
                        { type: 'separator' },
                        {
                            type: 'button',
                            model: {
                                commandName: 'splitTableCellVertically',
                                label: t('Split cell vertically')
                            }
                        },
                        {
                            type: 'button',
                            model: {
                                commandName: 'splitTableCellHorizontally',
                                label: t('Split cell horizontally')
                            }
                        }
                    ];
                    return _this._prepareDropdown(t('Merge cells'), tableMergeCellIcon, options, locale);
                });
            }    /**
     * Creates a dropdown view from the set of options.
     *
     * @private
     * @param {String} label The dropdown button label.
     * @param {String} icon An icon for the dropdown button.
     * @param {Array.<module:ui/dropdown/utils~ListDropdownItemDefinition>} options The list of options for the dropdown.
     * @param {module:utils/locale~Locale} locale
     * @returns {module:ui/dropdown/dropdownview~DropdownView}
     */
        },
        {
            key: '_prepareDropdown',
            value: function _prepareDropdown(label, icon, options, locale) {
                var editor = this.editor;
                var dropdownView = createDropdown(locale);
                var commands = [];
                // Prepare dropdown list items for list dropdown.
                var itemDefinitions = new Collection();
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;
                try {
                    for (var _iterator = options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var option = _step.value;
                        addListOption(option, editor, commands, itemDefinitions);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                addListToDropdown(dropdownView, itemDefinitions);
                // Decorate dropdown's button.
                dropdownView.buttonView.set({
                    label: label,
                    icon: icon,
                    tooltip: true
                });
                // Make dropdown button disabled when all options are disabled.
                dropdownView.bind('isEnabled').toMany(commands, 'isEnabled', function () {
                    for (var _len = arguments.length, areEnabled = new Array(_len), _key = 0; _key < _len; _key++) {
                        areEnabled[_key] = arguments[_key];
                    }
                    return areEnabled.some(function (isEnabled) {
                        return isEnabled;
                    });
                });
                this.listenTo(dropdownView, 'execute', function (evt) {
                    editor.execute(evt.source.commandName);
                    editor.editing.view.focus();
                });
                return dropdownView;
            }
        }
    ]);
    return TableUI;
}(Plugin);
// Adds an option to a list view.
//
// @param {module:table/tableui~DropdownOption} option Configuration option.
// @param {module:core/editor/editor~Editor} editor
// @param {Array.<module:core/command~Command>} commands List of commands to update.
// @param {Iterable.<module:ui/dropdown/utils~ListDropdownItemDefinition>} itemDefinitions
// Collection of dropdown items to update with given option.
export {
    TableUI as default
};
function addListOption(option, editor, commands, itemDefinitions) {
    var model = option.model = new Model(option.model);
    var _option$model = option.model, commandName = _option$model.commandName, bindIsOn = _option$model.bindIsOn;
    if (option.type !== 'separator') {
        var command = editor.commands.get(commandName);
        commands.push(command);
        model.set({ commandName: commandName });
        model.bind('isEnabled').to(command);
        if (bindIsOn) {
            model.bind('isOn').to(command, 'value');
        }
    }
    model.set({ withText: true });
    itemDefinitions.add(option);
}